import 'music/app/javascript/src/v3/main.js'
import { mountVueAppOnElm } from '~/src/shared/utils/vue.js'
import SchoolFindApp from '~/src/features/school_search/views/SchoolFindApp.vue';

window.addEventListener('DOMContentLoaded', () => {
  mountVueAppOnElm(SchoolFindApp, '.js-school-find-app', true);
});
